'use strict';

exports.__esModule = true;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Created by @玩家 on 2016/11/18.
 */

exports.default = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx, next) {
		var url, cookie, match, csrf_token;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						url = ctx.req.url;
						cookie = document.cookie;
						match = cookie && cookie.match(/(?:^|;)\s*xman_us_t\s*=\s*([^;]+)/);

						if (match) {
							match = match[1].match(/(?:^|&)\s*ctoken\s*=\s*([^&]+)/);
						}
						csrf_token = window['_intl_csrf_token_'] || match && match[1] || document.getElementsByName('_csrf_token')[0] && document.getElementsByName('_csrf_token')[0].value;


						if (csrf_token && isAlibabaAppUrl(url) && /(\?|&)ctoken=/.test(url) === false) {
							url += (/\?/.test(url) ? '&' : '?') + 'ctoken=' + csrf_token;
						}

						// 支持tbtoken
						match = cookie && cookie.match(/(?:^|;)\s*_tb_token_\s*=\s*([^;]+)/);

						if (match && /^https?:\/\/(pre-)?((expressexport|crosstrade|onepage|message|ta|bao|cashier|biz|onetouch|onetouch-partner|jsb|fin|lc|fin-partner)\.alibaba|(8|m\.8)\.1688)\.com\//.test(location.href) && /(\?|&)_tb_token_=/.test(url) === false) {
							url += (/\?/.test(url) ? '&' : '?') + '_tb_token_=' + match[1];
						}

						ctx.req.url = url;

						_context.next = 11;
						return next();

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	function csrfTokenMiddleware(_x, _x2) {
		return _ref.apply(this, arguments);
	}

	return csrfTokenMiddleware;
}();

function isAlibabaAppUrl(url) {
	var reAlibabaUrl = /^https?:\/\/(([^\:\/]+\.)?(alibaba|aliexpress|1688)\.com|\d+\.\d+\.\d+\.\d+|totoroserver.alibaba.net)(\:\d+)?\//i;
	var reStyleUrl = /^https?:\/\/(style|img)\.(alibaba|aliexpress)\.com(\:\d+)?\//i;
	return (reAlibabaUrl.test(url) || /^(\w+):\/\//i.test(url) === false && reAlibabaUrl.test(location.href)) && reStyleUrl.test(url) === false;
}
module.exports = exports['default'];